import client from './client';

export const listProducts = (category) => client.get('/api/products', { params: { category } });
export const getProduct = (slug) => client.get(`/api/products/${slug}`);
